import Grid from "@mui/material/Unstable_Grid2/Grid2";
import FormSectionGrid from "../Form/FormSectionGrid";
import FormSectionHeader from "../Form/FormSectionHeader";
import LabelValue from "./LabelValue";

const SpecialRequirements = ({
  pageText,
  candidateDetails,
  lookupData,
}: {
  pageText: any;
  candidateDetails: any;
  lookupData: any;
}) => {
  return (
    <>
      <FormSectionHeader>
        {pageText?.textMetadata?.specialrequirementtext}
      </FormSectionHeader>
      <FormSectionGrid>
        <Grid xs={12}>
          <LabelValue
            label={pageText?.labelsMetadata.anySpecialRequirementsLabel}
            value={
              lookupData?.specialRequirements[
                candidateDetails?.specialRequestType.value
              ]
            }
          />
        </Grid>
        {candidateDetails?.specialRequestMessage && (
          <Grid xs={12}>
            <LabelValue
              label={`Write to us ${pageText?.labelsMetadata.anySpecialRequirementsLabel}`}
              value={candidateDetails?.specialRequestMessage}
            />
          </Grid>
        )}
      </FormSectionGrid>
    </>
  );
};

export default SpecialRequirements;
